import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
export default function CalenderEdit({ item, onChange }) {


  useEffect(() => {

  }, [item]);

  let update = (ev) => {
    let tmpObj = Object.assign({}, item);

    if (ev.target.id === 'inactive') {
      tmpObj[ev.target.id] = ev.target.checked
    } else {
      tmpObj[ev.target.id] = ev.target.value;
    }
    if (ev.target.id === 'start' || ev.target.id === 'end') {
      tmpObj[ev.target.id] = moment(tmpObj[ev.target.id]).toDate();
    }
    //console.log(tmpObj.start,tmpObj.end);
    //if (tmpObj.start && tmpObj.end && moment(tmpObj.start).isAfter(moment(tmpObj.end))) {
    //  console.warn("Start date is after end date, setting end date to 1 hour after start date");
   //   tmpObj.end = moment(tmpObj.start).add(1, 'hours').toDate();
   // }
    onChange(tmpObj);
  }

  return (
    <div className="padding">
      <TextField
        margin="dense"
        id="title"
        label="Titel"
        type="text"
        value={item.title || ""}
        onChange={update}
        fullWidth
        readOnly={false}
        required
      />
      <TextField
        multiline
        margin="dense"
        id="description"
        label="Bericht"
        type="text"
        value={item.description || ""}
        onChange={update}
        readOnly={false}
        fullWidth
      />
      <TextField
        margin="dense"
        id="start"
        label="Start datum/tijd"
        type="datetime-local"
        value={moment(item.start).format("YYYY-MM-DDTHH:mm")}
        onChange={update}
        fullWidth
        readOnly={false}
        required
      />

      <TextField
        margin="dense"
        id="end"
        label="Eind datum/tijd"
        type="datetime-local"
        value={moment(item.end).format("YYYY-MM-DDTHH:mm")}
        onChange={update}
        fullWidth
        readOnly={false}
        required
      />

    </div>
  );

}

